import {shuffleArray} from "p3";
import definitions from "../../../definitions";
import QuestMinigame from "../QuestMinigame";

export default class MinigameSimonSays extends QuestMinigame {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._game = null;
        this._npc = null;

        this._noteMetadata = null;
        this._startingNotes = null;
        this._sequenceIncrementRate = null;

        this._notes = [];
        //this._sequences = [];
        this._currentSequence = 0;
        this._sequenceProgress = -1;
        this._correctSequence = null;
        this._submittedSequence = null;
        //this._unusedNotes = [];
        this._timer = {current:0, max:0.8};
        this._signalListeners = [];

        this.coins = 1;
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._noteMetadata = metadata.notes;
        //this._sequences = metadata.sequences;
        this._startingNotes = metadata.startingNotes;
        this._sequenceIncrementRate = metadata.sequenceIncrementRate;
        this.coins = metadata.coins;
    }

    /**
     * @param {GameScene} game
     */
    onMinigameStart(game) {
        if(this.isRunning)
            return;

        super.onMinigameStart(game);

        this._npc = game.findNPC(this.owner);
        this._game = game;

        const colours = [0x415ce0, 0xe6373a, 0x16b52e, 0xf0f016, 0x8d11f2];

        //console.log(this._game._enemies);

        this._notes = [];
        for(let i = 0; i < this._noteMetadata.length; i++) {
            //console.log(this._noteMetadata[i]);
            const note = this._game.findEnemy(this._noteMetadata[i]);
            this._signalListeners.push(note.signals.struck.add(this.onNoteStrike, this));
            this._notes.push(note);
            //console.log(note);
            note.colour = colours[i];
        }

        this._playSong(true);
    }

    /**
     * @param {EnemySimonSays} note
     */
    onNoteStrike(note) {
        if (note.uid == this._correctSequence[this._submittedSequence.length].uid) {
            this._submittedSequence.push(note);
            if (this._submittedSequence.length == this._correctSequence.length) {
                this._currentSequence ++;
                this.score ++;
                //this._correctSequence = null;
                this._playSong(true);
            }
        } else {
            this._game.onEnemyAttack(note, null, note.damage);
            this._playSong(false);
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameUpdate(game) {
        super.onMinigameUpdate();
        if (this.isRunning) {

            if (this._sequenceProgress >= 0) {
                this._timer.current += window.dt;
                if (this._timer.current >= this._timer.max) {
                    this._correctSequence[this._sequenceProgress].soundOut();
                    this._sequenceProgress++;
                    this._timer.current = 0;
                    if (this._sequenceProgress >= this._correctSequence.length) {
                        this._sequenceProgress = -1;
                        this._enableUserHits();
                    }
                }
            }
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameEnd(game) {
        super.onMinigameEnd(game);
        for (let i in this._signalListeners) {
            this._signalListeners[i].detach();
        }
        this.bestScore = this.score;
        this._enableUserHits();
    }

    onMinigameCancel(game) {
        super.onMinigameCancel(game);
    }

    _playSong(add = false)
    {
        /*
        if(this._correctSequence == null) {
            const sequence = this._sequences[Math.min(this._currentSequence, this._sequences.length-1)];
            //console.log(sequence);
            const noteTypes = this._notes.slice();
            let i;
            for (i = 0; i <= Math.max(0, noteTypes.length - sequence.maxNotes); i++) {
                noteTypes.splice(Math.floor(Math.random() * noteTypes.length), 1);
            }
            this._correctSequence = noteTypes.slice();
            for (i = 0; i < sequence.repeatNotes; i++) {
                this._correctSequence.push(noteTypes[Math.floor(Math.random() * noteTypes.length)]);
            }
            shuffleArray(this._correctSequence);
        }*/

        
        if (add) {
            let i;
            if(this._correctSequence == null) {
                this._correctSequence = this._notes.slice();
                
                for (i = 0; i <= Math.max(0, this._correctSequence.length - this._startingNotes); i++) {
                    //this._unusedNotes.push(
                        this._correctSequence.splice(Math.floor(Math.random() * this._correctSequence.length), 1);
                    //);
                }
            } else {
                /*if (this._unusedNotes.length > 0 && Math.random() > 0.5) {
                    this._correctSequence.push(this._unusedNotes.splice(Math.floor(Math.random() * this._unusedNotes.length), 1));
                } else {*/
                for (i = 0; i <= Math.floor(this._currentSequence / this._sequenceIncrementRate); i++) {
                    this._correctSequence.push(this._notes[Math.floor(Math.random() * this._notes.length)]);
                }
                //}
            }
        }

        this._sequenceProgress = 0;
        this._disableUserHits();
        this._submittedSequence = [];
    }

    _disableUserHits() {
        for( let i in this._notes) {
            this._notes[i].allowStrike = false;
        }
    }

    _enableUserHits() {
        for( let i in this._notes) {
            this._notes[i].allowStrike = true;
        }
    }
}